// App专用路由,注释路由就不会被构建 vite扫描 到
import type { RouteRecordRaw } from 'vue-router'
const routes: RouteRecordRaw[] = [
  // App视频通话
  {
    path: '/roomApp/call',
    name: 'RoomAppCall',
    component: () => import('@/pages/Inapp/RoomApp/Call.vue')
  },
  // App直播房
  {
    path: '/roomApp/live',
    name: 'RoomAppLive',
    component: () => import('@/pages/Inapp/RoomApp/Live.vue')
  },
  // App语音房
  {
    path: '/roomApp/audio',
    name: 'RoomAppAudio',
    component: () => import('@/pages/Inapp/RoomApp/Audio.vue')
  }
]

export default routes
